module.exports = __webpack_public_path__ + "static/img/logo_login_jns_white.1abbe95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_login_jns_white.png
// module id = u00v
// module chunks = 0